import React, { CSSProperties, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, css, fonts, glyphs } from '../../Styles';
import { EventNotePopover, NewModal, MainContentPaddingTypes, NewButton } from '..';
import { useAnimal } from '../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/useAnimal';
import { useAppSelector } from '../../Store';
import { Graph_QL } from '../../Services';
import { AnimalInfo } from '../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall';
import { LocaleFarmDate } from '../../Definitions/localeFarmDate';
import { ButtonTypes } from '../../Definitions';

// #region | Event colors
export const eventColors = [
  colors.graphBlueOne,
  colors.graphBlueTwo,
  colors.graphBlueThree,
  colors.graphBlueFour,
  colors.graphBlueFive,
  colors.graphBlueSix,
  colors.graphBlueSeven,
  colors.graphBlueEight,
  colors.graphBlueNine,
  colors.graphBlueTen,
  colors.graphBlueEleven,
  colors.graphBlueTwelve
];  
// #endregion

// #region | Timeline version
/* eslint-disable */
export enum timelineTypes {
  verticalModal="verticalModal",
  horizontalModal="horizontalModal",
  primary="primary"
}
/* eslint-enable */

// Define popover position based on popover orientation
export const createTimelineTypes = (timelineType: timelineTypes, index: number = 0, daysDiff?: number, totalDays?: number) => {
  let componentContainerStyles: CSSProperties;
  let timelineContainerStyles: CSSProperties;
  let timelineSubContainerStyles: CSSProperties;
  let timelineStyles : CSSProperties;
  let flagContainerStyles: CSSProperties;
  let flagStyles: CSSProperties;
  let flagDayMonthStyles: CSSProperties;
  let flagSubContainerStyles: CSSProperties;
  let flagEventName: CSSProperties;
  const relativePosition = ((daysDiff ?? 0) / (totalDays ?? 0)) * 100; 
  const backgroundColor = eventColors[(index ?? 0) % eventColors.length];

  switch (timelineType) {
    case timelineTypes.verticalModal:
      componentContainerStyles = {
        flexDirection: "row"
      }
      timelineContainerStyles = {
        width: "100%", 
        minWidth: "300px", 
        padding: "10px 0px"
      }
      timelineSubContainerStyles = {
        height: "340px",
        width: "300px",
        marginRight: "0px",
        marginBottom: "90px"
      }
      timelineStyles = {
        top:"0px",
        left: "50%",
        bottom: "-85px",
        right: "unset",
        borderTop: "none",
        borderLeft: "2px dashed"+colors.greyDarkPrimary
      }
      flagContainerStyles = {
        bottom: "unset",
        top: `${relativePosition}%`,
        left: index % 2 === 0 ? "" : "10px",
        right: index % 2 === 0 ? "10px" : "",
        borderLeft: "none",
        borderTop: `3px solid ${backgroundColor}`,
        padding: "5px 0px 0px 0px",
        height: "fit-content",
        width: "160px",
        flexDirection: index % 2 === 0 ? "row-reverse" : "row",
      }
      flagStyles = {
        background: `${backgroundColor}`, width: "40px", height: "40px",
        
      }
      flagDayMonthStyles = {
        ...fonts.fontSize4 
      }
      flagSubContainerStyles = {
        flexDirection: "column", alignItems: index % 2 === 0 ? "end" : "start"
      }
      flagEventName = {
        color: colors.greyDarkPrimary,
        textAlign: index % 2 === 0 ? "right" : "left"
      }
      break;
    case timelineTypes.horizontalModal:
      componentContainerStyles = {
        flexDirection: "column-reverse"
      }
      timelineContainerStyles = {
        width: "80%", 
        minWidth: "550px", 
        // padding: "0px 60px"
      }
      timelineSubContainerStyles = {
        height: "300px",
        width: "100%",
        marginRight: "90px",
        marginBottom: "0px"
      }
      timelineStyles = {
        top: "50%",
        left: "0px",
        bottom: "unset",
        right: "-85px",
        borderTop: "2px dashed"+colors.greyDarkPrimary,
        borderLeft: "none"
      }
      flagContainerStyles = {
        bottom: "30px",
        top: index % 2 === 0 ? "30px" : "",
        left: `${relativePosition}%`,
        right: "unset",
        borderLeft: `3px solid ${backgroundColor}`,
        borderTop: "none",
        padding: "0px 0px 0px 5px",
        height: "130px",
        width: "fit-content",
        flexDirection: index % 2 === 0 ? "column" : "column-reverse",
      };
      flagStyles = {
        background: `${backgroundColor}`, width: "50px", height: "50px",
      }
      flagDayMonthStyles = {
      ...fonts.fontSize3
      }
      flagSubContainerStyles = {
        flexDirection: index % 2 === 0 ? "column" : "column-reverse", alignItems: "start"
      }
      flagEventName = {
        color: colors.greyDarkPrimary,
        textAlign: index % 2 === 0 ? "right" : "left"
      }
      break;
    case timelineTypes.primary:
    default:
      componentContainerStyles = {
        flexDirection: "row" 
      }
      timelineContainerStyles = {
        width: "80%", 
        minWidth: "unset", 
        padding: "0px"
      }
      timelineSubContainerStyles = {
        height: "300px",
        width: "100%",
        marginRight: "90px",
        marginBottom: "0px"
      }
      timelineStyles = {
        top: "50%",
        left: "0px",
        bottom: "unset",
        right: "-85px",
        borderTop: "2px dashed"+colors.greyDarkPrimary,
        borderLeft: "none"
      }
      flagContainerStyles = {
        bottom: "30px",
        top: index % 2 === 0 ? "30px" : "",
        left: `${relativePosition}%`,
        right: "unset",
        borderLeft: `3px solid ${backgroundColor}`,
        borderTop: "none",
        padding: "0px 0px 0px 5px",
        height: "130px",
        width: "fit-content",
        flexDirection: index % 2 === 0 ? "column" : "column-reverse",
      };
      flagStyles = {
        background: `${backgroundColor}`, width: "50px", height: "50px",
      }
      flagDayMonthStyles = {
        ...fonts.fontSize3
      }
      flagSubContainerStyles = {
        flexDirection: index % 2 === 0 ? "column" : "column-reverse", alignItems: "start"
      }
      flagEventName = {
        color: colors.greyLightTertiary,
        textAlign: index % 2 === 0 ? "right" : "left"
      }
      break;
  }
  return { 
    flagContainerStyles, 
    flagStyles, 
    flagDayMonthStyles, 
    flagSubContainerStyles, 
    flagEventName, 
    componentContainerStyles,
    timelineContainerStyles,
    timelineSubContainerStyles,
    timelineStyles
  };
};
// #endregion

interface Timeline_Props {
  selectedAnimal: number;
  timelineType?: timelineTypes
  isModalOpen?: boolean
  closeModal?: () => void,
}
/**
 * Timeline
 * @param selectedAnimal The ID of the selected animal.
 * @param timelineType The type of timeline to be displayed (default: primary).
 * @param isModalOpen Determines if the modal is open.
 * @param closeModal Function to close the modal.
 * @returns A timeline visualization of the selected animal's events.
 */
export default function Timeline({ selectedAnimal, timelineType = timelineTypes.primary, isModalOpen = false, closeModal }: Timeline_Props) {
  const {t} = useTranslation()
  const [currentParityIndex, setCurrentParityIndex] = useState<number>(0);
  const { 
    componentContainerStyles,
    timelineContainerStyles,
    timelineSubContainerStyles,
    timelineStyles
  } = createTimelineTypes(timelineType);

  // Find selected animal
  
  const farm = useAppSelector(({activeData}) => activeData.farm) ?? "";
  const domain = useMemo(() => (Graph_QL.ObjToString({domain: farm})),[farm]);
  const connection = useMemo(() => (Graph_QL.create({domain: farm})),[farm]); const { call: getAnimalsInfo, data: animalsState} = useAnimal(connection);
 
  const animal = useMemo(() => {
    return animalsState && animalsState[domain] ? animalsState[domain].data.find((animal) => animal.animal_id === selectedAnimal) : undefined
  },[animalsState, domain, selectedAnimal])
  
  useEffect(() => {
    if (selectedAnimal && selectedAnimal !== 0) {
      getAnimalsInfo({ids:[selectedAnimal], ifFeedCurveBaseInfoOnly: false, ifSkipLastTenDaysConsumption: false}, connection)
    }
  }, [connection, getAnimalsInfo, selectedAnimal])

  // #region | Timeline

  // Set most lately parity as the first to view
  useEffect(() => {
    if (animal && animal.event) {
      const parities = groupEventsByParity(animal, t("animalPages.animal.born", {defaultValue: "Born"}));
      const initialParityIndex = parities.length > 0 ? parities.length - 1 : 0;
      setCurrentParityIndex(initialParityIndex);
    }
  }, [animal, t]);

  // Fallback if there is no animal or animal has no calendar
  if (!animal || !animal.event) {
    return <div style={{ ...css.emptyPen, color: colors.greyLightTertiary, display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>{t("animalPages.animal.noTimeline", {defaultValue: "No Timeline"})}</div>;
  }
  
  const parities = groupEventsByParity(animal, t("animalPages.animal.born", {defaultValue: "Born"}));
  const currentParity = parities[currentParityIndex] || [];

  if (!currentParity.length && currentParityIndex !== 0) {
    setCurrentParityIndex(0);
    return null
  }
  
  const startDate = currentParity[0]?.timestamp;
  const endDate = currentParity.at(-1)?.timestamp;
  if (!startDate || !endDate) {
    return null
  }

  const totalDays = Math.max(1, Math.floor((new Date(endDate).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24)));
  // #endregion
    
  // #region | Event Flags for timeline
  const renderParityEvents = (parity: any[]) => {
    return parity.map((event, index) => {
      const daysDiff = Math.floor((new Date(event.timestamp).getTime() - new Date(startDate).getTime()) / (1000 * 60 * 60 * 24));
      const localeFarmDate = new LocaleFarmDate(event.timestamp);
      const dayMonth = localeFarmDate.toDayMonth();
      const year = localeFarmDate.toYear();
      const { 
        flagContainerStyles, 
        flagStyles, 
        flagDayMonthStyles, 
        flagSubContainerStyles, 
        flagEventName 
      } = createTimelineTypes(timelineType, index, daysDiff, totalDays);
    
      return (
        <div key={event.eventNo} style={{position: "absolute", gap: "5px", display: "flex", ...flagContainerStyles}}>
          <div style={{padding: "3px", flexDirection: "column", alignItems: "center", justifyContent: "center", display: "flex", borderRadius: "5px", ...flagStyles}}>
            <p style={{...fonts.header, color: colors.whitePrimary, ...flagDayMonthStyles}}>{dayMonth}</p>
            <p style={{ ...fonts.fontSize4, ...fonts.header, color: colors.whitePrimary }}>{year}</p>
          </div>
          <div style={{display: "flex", gap: "5px", ...flagSubContainerStyles}}>
            <div>
              <p style={{...fonts.fontSize4, ...fonts.header, ...flagEventName}}>{event.eventName}</p>
            </div>
            {event.note && (
              <EventNotePopover 
                eventName={event.eventName} 
                eventNote={event.note} 
                glyphColor={timelineType !== timelineTypes.primary ? colors.greyDarkPrimary : colors.greyLightTertiary}
              />
            )}
          </div>
        </div>
      );
    });
  };
  // #endregion

  // #region | Parity Buttons
  const previousParityBtn = (
    <NewButton content={""} 
      startEnhancer={glyphs.Arrow({rotate: 180})}
      buttonType={ButtonTypes.arrowButton}
      onClick={() => setCurrentParityIndex((prevIndex) => (prevIndex - 1 + parities.length) % parities.length)}
      overrides={{
        // baseStyles: { height: "30px", width: "35px" },
        // startEnhancerStyles: { left: "50%", transform: "translate(-50%, -50%)", height: "20px" }
      }}
    />
  )

  const nextParityBtn = (
    <NewButton content={""} 
      startEnhancer={glyphs.Arrow({})}
      buttonType={ButtonTypes.arrowButton}
      onClick={() => setCurrentParityIndex((prevIndex) => (prevIndex + 1) % parities.length)}
      overrides={{
        // baseStyles: {height: "30px", width: "35px"},
        // startEnhancerStyles: { left: "50%", transform: "translate(-50%, -50%)", height: "20px" }
      }}
    />
  )
  // #endregion

  // #region | Time line
  const timeline = (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", ...timelineContainerStyles}}>
      <div style={{position: "relative", ...timelineSubContainerStyles}}>
        {/* Timeline line */}
        <div style={{position: 'absolute', ...timelineStyles}}/>
        {/* Event flags */}
        {renderParityEvents(parities[currentParityIndex])}
      </div>
    </div>
  )
  // #endregion

  return ( <>      
    {(timelineType !== timelineTypes.primary) ?
      <NewModal 
        modalState={isModalOpen}
        header={t("animalPages.animal.timeline", {defaultValue: "Timeline"})}  
        subHeader={`${t("animalPages.animal.animal", {defaultValue: "Animal"})} ${selectedAnimal} ${t("animalPages.animal.parity", {defaultValue: "Parity"})} ${animal.birthday ? currentParityIndex : currentParityIndex + 1}`}
        predefinedButtons={{
          onClose: closeModal,
          onNext: () => setCurrentParityIndex((prevIndex) => (prevIndex + 1) % parities.length),
          onPrev: () => setCurrentParityIndex((prevIndex) => (prevIndex - 1 + parities.length) % parities.length)
        }}
        overrides={{
          mainContentPadding: MainContentPaddingTypes.primary,
          backgroundColor: colors.greyLightTertiary
        }}
        mainContent={
          <>{timeline}</>
        }
      />             
    : <div style={{position: "relative", width: "100%", height: "fit-content", display: "flex", justifyContent: "center", alignItems: "center", ...componentContainerStyles}}>
        <p style={{position: "absolute", top: "0px", left: "0px", color: colors.greyLightTertiary, ...fonts.fontSize4, ...fonts.header}}>
          {`${t("animalPages.animal.timelineShows", {defaultValue: "Timeline shows parity"})} ${animal.birthday ? currentParityIndex : currentParityIndex + 1}`}
        </p>
        <div style={{width: "100%", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between"}}>
          {previousParityBtn}
          {timeline}
          {nextParityBtn}
        </div>
      </div> 
    }
  </>) ;
}


const groupEventsByParity = (animal: AnimalInfo, birthEvenLabel: string) => {
  const events = animal.event ? [...animal.event] : [];
  
  // If animal has a birth date push it as an event
  if (animal.birthday) {
    events.push({ eventNo: 0, timestamp: new Date(animal.birthday).toISOString(), eventName: birthEvenLabel});
  }

  events.sort((a, b) => new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime());

  let parities: any[] = [];
  let currentParity: any[] = [];

  events.forEach((event, index) => {
    // if (event.milestoneId === 2 && currentParity.length > 0) {
      // parities.push(currentParity);
      // currentParity = [];
    // }
  currentParity.push(event);
  });

  if (currentParity.length) parities.push(currentParity);
  return parities;
};